















































































import Vue from 'vue';
import Component from 'vue-class-component';
import { FeeSheetTemplateService } from '../../service/FeeSheetTemplateService';
import { AgentService } from '../../service/AgentService';
import { ClientService } from '../../service/ClientService';
import { DataGrid } from '@questelservices/common-vue';
import {
  DxColumn,
  DxEditing,
  DxForm,
  DxFormItem,
  DxHeaderFilter,
  DxPaging,
  DxLookup,
  DxPopup,
  DxDataGrid,
  DxFilterRow  
} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import { DxSelectBox, DxButton } from 'devextreme-vue';
import DevExpress from 'devextreme/bundles/dx.all';
import CustomStore from 'devextreme/data/custom_store';

@Component({
  components: {
    DxSelectBox,
    DataGrid,
    DxColumn,
    DxEditing,
    DxForm,
    DxFormItem,
    DxHeaderFilter,
    DxItem,
    DxLookup,
    DxPopup,
    DxDataGrid,
    DxPaging,
    DxFilterRow,
    DxButton
  }
})
export default class FeeSheetTemplatesGrid extends Vue {
  feeSheetTemplatesService: FeeSheetTemplateService;
  dataGrid: any;  
  feeSheetTemplatesCustomStoreOptions: DevExpress.data.CustomStoreOptions;

  templateIdToDelete: Guid = "";

  constructor() {
    super();

    this.feeSheetTemplatesService = new FeeSheetTemplateService(
      '/api/FeeSheetTemplate'
    );

    this.feeSheetTemplatesCustomStoreOptions = {
      key: 'FeeSheetTemplateId',
      load: loadOptions => this.feeSheetTemplatesService.search(loadOptions),
    };
  }

  dataGridInitialized(e: any): void {
    this.dataGrid = e.component;
  }

  saveEditData(): void {
    if (this.dataGrid) {
      this.dataGrid.focus();
      this.dataGrid.saveEditData();
    }
  }

  createNewFeeSheetTemplate(row: any) : void {
    this.$router.push('/fee-sheet-templates-form');
  }

  editFeeSheetTemplate(row: any) : void {
    this.$router.push(`/fee-sheet-templates-form/${row.FeeSheetTemplateId}`);
  }

  deleteFeeSheetTemplate() {
    this.feeSheetTemplatesService.delete(this.templateIdToDelete)
      .then(result => {
        this.refreshDataGrid();
      });
  }

  private refreshDataGrid() {
    if (this.dataGrid != null) {
      this.dataGrid.refresh();
    }
  }

  customizeNullText(info: any) {
    return info.valueText === '' ? 'ALL' : info.valueText;
  }

  showDelete(row: any): void {    
    this.templateIdToDelete = row.FeeSheetTemplateId;
    this.$emit('showingDelete');
  }
}
